import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';

import { SText } from 'components/styled/SText';
import { Button } from 'components/ui/Button';

export const PaymentConfirmationPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    padding: 0 16px 16px;
  }
`;

export const ConfirmationText = styled(SText)`
  font-size: 16px;
  line-height: 24px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const ConfirmButton = styled(Button)`
  width: 100%;
`;

export const CancelButton = styled(Button)`
  width: 100%;
  border-color: ${EColors.Red1};
  color: ${EColors.Red1};

  &:hover {
    border-color: ${EColors.Red1};
    background-color: ${EColors.Red1};
  }
`;
